import {
  Component,
  Input,
  OnInit,
  OnChanges,
  ViewChild,
  Output,
  EventEmitter,
  OnDestroy
} from '@angular/core';
import { MatSort, Sort } from '@angular/material/sort';
import { CommonPropertyDetailConstant } from '../common-property-detail-page.constant';
import { CommonPropertyDetailPageService } from '../common-property-detail-page.service';
import { ReportService } from 'src/app/reports/services/report.service';
import { takeUntil, Subject, Subscription } from 'rxjs';
import { SharedService } from 'src/app/common/services/shared.service';
import { CommonPropertyDetailMenuEnum } from '../common-property-detail-page.enum';

@Component({
  selector: 'app-residential-rental-details-table',
  templateUrl: './residential-rental-details-table.component.html',
  styleUrls: ['./residential-rental-details-table.component.scss'],
})
export class ResidentialRentalDetailsTableComponent implements OnInit, OnChanges, OnDestroy {
  @Input() property_uid: string = '';
  @Output() sort: EventEmitter<Sort> = new EventEmitter();
  @ViewChild(MatSort) matSort!: MatSort;
  
  @Output() isEmpatyCheck = new EventEmitter();

  overViewMenu = CommonPropertyDetailConstant.overViewMenu;
  current_lang: string = 'en';
  tableColumns: any[] = CommonPropertyDetailConstant.propertyResidentialColumns;
  tableData: any[] = [];
  showLoader: boolean = false;

  private destroy$ = new Subject<void>();
  private languageSub$: Subscription = new Subscription();

  sortOrder: string = ''; // track sort order

  constructor(
    private propertyService: CommonPropertyDetailPageService,
    private reportService: ReportService,
    private sharedService: SharedService
  ) {
    this.languageSub$ = this.sharedService.language$.subscribe((lang) => {
      this.current_lang = lang;
      if(this.property_uid){
        this.fetchData();
      }
    });
  }

  ngOnInit(): void {
    if(this.sharedService.priceCalculation$() === this.sharedService.priceYearly){
      this.tableColumns[3].columnName = "reports.avg_annual_rent_rate"
    }
  }

  ngOnChanges(): void {
    if (this.property_uid) {
      this.fetchData();
    }
  }

  fetchData(): void {
    this.showLoader = true;
    this.propertyService
      .getPropertyRental(20, 0, this.sortOrder, this.property_uid, 'residential')
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          this.showLoader = false;
          if (res.status === 200) {
            this.tableData = this.reportService.setTableDataSource(res.data);
            this.isEmpatyCheck.emit(false);
          } else {
            this.tableData = [];
            this.isEmpatyCheck.emit(true);
          }
        },
        error: () => {
          this.showLoader = false;
          this.tableData = [];
          this.isEmpatyCheck.emit(true);
        },
      });
  }

  onSortTable(event: Sort) {
    this.sort.emit(event);
    this.sortOrder = event.direction
      ? JSON.stringify({ column: event.active, order: event.direction }).replace(/[+]/g, '%2B')
      : '';
    this.fetchData();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.languageSub$.unsubscribe();
  }
}
